(function () {
  function init() {
    var bar = document.querySelector('[data-arclo-sticky-cart]');
    if (!bar) return;

    var buyButtonsWrap = document.querySelector('.product-form__buttons');
    var realSubmitBtn = document.querySelector('[id^="ProductSubmitButton-"]');
    var realPriceEl = document.querySelector('.product__info-wrapper .price');
    // Dawn replaces the *contents* of the price wrapper (id^="price-") on a
    // variant change, which destroys/recreates the inner .price node. Watch
    // the stable wrapper instead of the inner node, and always re-query the
    // inner node fresh when syncing so we never mirror from a disconnected
    // reference.
    var realPriceWrap = realPriceEl ? realPriceEl.closest('[id^="price-"]') || realPriceEl.parentElement : null;
    var realQtyInput = document.querySelector('.product__info-wrapper .quantity__input');
    var realQtyWrap = realQtyInput ? realQtyInput.closest('quantity-input') : null;
    var realQtyMinusBtn = realQtyWrap ? realQtyWrap.querySelector('[name="minus"]') : null;
    var realQtyPlusBtn = realQtyWrap ? realQtyWrap.querySelector('[name="plus"]') : null;

    if (!buyButtonsWrap || !realSubmitBtn) {
      // Main product markup not rendered yet (e.g. section loading async) — retry shortly.
      window.setTimeout(init, 300);
      return;
    }

    bar.hidden = false;

    var priceSlot = bar.querySelector('[data-arclo-sticky-price]');
    var stickyBtn = bar.querySelector('[data-arclo-sticky-add-to-cart]');
    var stickyBtnLabel = bar.querySelector('[data-arclo-sticky-btn-label]');
    var defaultLabel = stickyBtnLabel ? stickyBtnLabel.textContent : 'Add to cart';
    var optionSelects = bar.querySelectorAll('[data-arclo-sticky-option]');
    var stickyQtyInput = bar.querySelector('[data-arclo-sticky-qty-input]');
    var stickyQtyMinus = bar.querySelector('[data-arclo-sticky-qty-minus]');
    var stickyQtyPlus = bar.querySelector('[data-arclo-sticky-qty-plus]');

    function syncPrice() {
      if (!priceSlot) return;
      // Re-query the live price node each time rather than trusting a
      // captured reference, since Dawn swaps it out on variant change.
      var currentPriceEl = realPriceWrap
        ? realPriceWrap.querySelector('.price')
        : document.querySelector('.product__info-wrapper .price');
      if (currentPriceEl) {
        priceSlot.innerHTML = currentPriceEl.innerHTML;
        // Dawn's own CSS keys badge visibility/sizing (price--on-sale,
        // price--sold-out, price--show-badge, price--large, ...) off the
        // real price element's class list. Mirror it (keeping our own
        // layout class) so the copy picks up exactly the same rules
        // instead of falling back to unstyled defaults.
        priceSlot.className = 'arclo-sticky-cart__price ' + currentPriceEl.className;
      }
    }

    function syncButtonState() {
      if (!stickyBtn || !realSubmitBtn) return;
      var isDisabled = !!realSubmitBtn.disabled;
      stickyBtn.disabled = isDisabled;
      if (stickyBtnLabel) {
        stickyBtnLabel.textContent = isDisabled
          ? ((realSubmitBtn.textContent || '').trim() || 'Sold out')
          : defaultLabel;
      }
    }

    function syncQtyFromReal() {
      if (realQtyInput && stickyQtyInput && stickyQtyInput.value !== realQtyInput.value) {
        stickyQtyInput.value = realQtyInput.value;
      }
    }

    function syncOptionsFromReal() {
      optionSelects.forEach(function (select) {
        var options = select.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var valueId = options[i].value;
          var realInput = document.querySelector('[data-option-value-id="' + valueId + '"]');
          if (realInput && realInput.checked && select.value !== valueId) {
            select.value = valueId;
            break;
          }
        }
      });
    }

    syncPrice();
    syncButtonState();
    syncQtyFromReal();

    if (realPriceWrap && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(realPriceWrap, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(syncButtonState).observe(realSubmitBtn, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true
      });
    }

    // Variant option selects: clicking the sticky dropdown drives the real
    // (hidden, scrolled-past) variant picker, so price/availability/media
    // stay governed by the theme's own variant-selects logic.
    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var valueId = select.value;
        var realInput = document.querySelector('[data-option-value-id="' + valueId + '"]');
        if (realInput && !realInput.checked) {
          realInput.click();
        }
      });
    });

    // Keep the sticky selects in sync if the shopper changes the variant
    // from the main picker instead (e.g. scrolls back up). Delegate from a
    // stable ancestor since variant-selects' own subtree can be replaced.
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('variant-selects')) {
        syncOptionsFromReal();
      }
    });

    // Quantity stepper: forward to the real +/- buttons so the theme's own
    // min/max/step rules keep being enforced, then mirror the result back.
    if (stickyQtyMinus) {
      stickyQtyMinus.addEventListener('click', function () {
        if (realQtyMinusBtn) realQtyMinusBtn.click();
      });
    }
    if (stickyQtyPlus) {
      stickyQtyPlus.addEventListener('click', function () {
        if (realQtyPlusBtn) realQtyPlusBtn.click();
      });
    }
    if (stickyQtyInput) {
      stickyQtyInput.addEventListener('change', function () {
        if (!realQtyInput) return;
        var qty = parseInt(stickyQtyInput.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        stickyQtyInput.value = qty;
        realQtyInput.value = qty;
        realQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (realQtyInput) {
      realQtyInput.addEventListener('change', syncQtyFromReal);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
          } else if (entry.boundingClientRect.top < 0) {
            // Real buy button has been scrolled up past the top of the viewport.
            bar.classList.add('is-visible');
          } else {
            // Real buy button hasn't been reached yet (below the viewport).
            bar.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });
      observer.observe(buyButtonsWrap);
    } else {
      bar.classList.add('is-visible');
    }

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      realSubmitBtn.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
